import React, { useState } from "react";
import { Badge, Button, Card, Col, Collapse, Dropdown, Form, Image, Row } from "react-bootstrap";
import SimpleBar from "simplebar-react";

// img
import logosm from "assets/images/logo-sm.png";

const CommondDropdown = () => {
  return (
    <Dropdown as="div" className="align-self-start message-box-drop">
      <Dropdown.Toggle as="a">
        <i className="ri-more-2-fill" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item href="#/action-1">
          <i className="ri-reply-line me-2 text-muted align-bottom" />
          Reply
        </Dropdown.Item>
        <Dropdown.Item href="#/action-2">
          <i className="ri-file-copy-line me-2 text-muted align-bottom" />
          Copy
        </Dropdown.Item>
        <Dropdown.Item href="#/action-3">
          <i className="ri-delete-bin-5-line me-2 text-muted align-bottom" />
          Delete
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const OnlineChat = () => {
  const [chat, setChate] = useState(false);
  const [clickedOnce, setClickedOnce] = useState(false);

  const toggleChat = () => {
    setClickedOnce(true);
    setChate((v) => !v);
  };

  return (
    <React.Fragment>
      <Button
        variant="danger"
        className="btn shadow-lg chat-button rounded-bottom-0 d-none d-lg-block"
        onClick={toggleChat}
        aria-controls="chatBot"
        aria-expanded={chat}
      >
        FionaZiya Chat
      </Button>

      <Collapse in={chat}>
        <div id="chatBot">
          <div className="chat-box">
            <Card className="shadow-lg border-0 rounded-bottom-0 mb-0">
              <Card.Header className="bg-success d-flex align-items-center border-0">
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                  <h5 className="text-white fs-16 fw-medium mb-0">Hi, welcome to FionaZiya 👋</h5>

                  {/* ✅ badge INSIDE chat header (shows after first click) */}
                  {clickedOnce && (
                    <Badge bg="warning" text="dark" className="ms-2">
                      Coming Soon
                    </Badge>
                  )}
                </div>

                <Button
                  className="btn-close btn-close-white flex-shrink-0"
                  onClick={toggleChat}
                  data-bs-dismiss="collapse"
                  aria-label="Close"
                />
              </Card.Header>

              <Card.Body className="p-0">
                <SimpleBar style={{ height: 280 }}>
                  <div id="users-chat-widget">
                    <div className="chat-conversation p-3" id="chat-conversation" data-simplebar="">
                      <ul className="list-unstyled chat-conversation-list chat-sm" id="users-conversation">
                        <li className="chat-list left">
                          <div className="conversation-list">
                            <div className="chat-avatar">
                              <Image src={logosm} alt="" />
                            </div>

                            <div className="user-chat-content">
                              <div className="ctext-wrap">
                                <div className="ctext-wrap-content">
                                  <p className="mb-0 ctext-content">
                                    Welcome to FionaZiya. We’re here to help you.
                                    <br />
                                    Please share your question and our team will reply shortly.
                                  </p>
                                </div>
                                <CommondDropdown />
                              </div>

                              <div className="conversation-name">
                                <small className="text-muted time">09:07 am</small>{" "}
                                <span className="text-success check-message-icon">
                                  <i className="ri-check-double-line align-bottom" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li className="chat-list right">
                          <div className="conversation-list">
                            <div className="user-chat-content">
                              <div className="ctext-wrap">
                                <div className="ctext-wrap-content">
                                  <p className="mb-0 ctext-content">Hello 👋 I need help with my order / product.</p>
                                </div>
                                <CommondDropdown />
                              </div>

                              <div className="conversation-name">
                                <small className="text-muted time">09:08 am</small>{" "}
                                <span className="text-success check-message-icon">
                                  <i className="ri-check-double-line align-bottom" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li className="chat-list left">
                          <div className="conversation-list">
                            <div className="chat-avatar">
                              <Image src={logosm} alt="" />
                            </div>

                            <div className="user-chat-content">
                              <div className="ctext-wrap">
                                <div className="ctext-wrap-content">
                                  <p className="mb-0 ctext-content">
                                    Sure! Please tell us your issue (order ID / product name), and we’ll assist you.
                                  </p>
                                </div>
                                <CommondDropdown />
                              </div>

                              <div className="conversation-name">
                                <small className="text-muted time">09:10 am</small>{" "}
                                <span className="text-success check-message-icon">
                                  <i className="ri-check-double-line align-bottom" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </SimpleBar>

                <div className="border-top border-top-dashed">
                  <Row className="g-2 mt-2 mx-3 mb-3">
                    <Col>
                      <div className="position-relative">
                        <Form.Control className="border-light bg-light" placeholder="Enter Message..." />
                      </div>
                    </Col>
                    <Col className="col-auto">
                      <Button type="submit" variant="info">
                        <i className="mdi mdi-send" />
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

export default OnlineChat;